import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/layout';
import ProtectedRoute from './components/layout/protected-route';

// Pages
import HomePage from './pages/home';

// About Pages
import AboutPage from './pages/about';
import ExecutivesPage from './pages/about/executives';
import ExecutiveDetailPage from './pages/about/executive-detail';

// Membership Pages
import MembershipCategoriesPage from './pages/membership/membership-categories';
import MembershipBenefitsPage from './pages/membership/membership-benefits';
import MembershipCodeOfEthicsPage from './pages/membership/membership-code-of-ethics';
import MembershipApplicationPage from './pages/membership/membership-application';
import ApplicationStatusPage from './pages/membership/application-status';
import ApplicationSuccessPage from './pages/membership/application-success';

// Contact Page
import ContactPage from './pages/contact';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Membership routes - always accessible */}
          <Route path="/membership/categories" element={
            <Layout>
              <MembershipCategoriesPage />
            </Layout>
          } />
          <Route path="/membership/benefits" element={
            <Layout>
              <MembershipBenefitsPage />
            </Layout>
          } />
          <Route path="/membership/code-of-ethics" element={
            <Layout>
              <MembershipCodeOfEthicsPage />
            </Layout>
          } />
              <Route path="/membership/application" element={
                <Layout>
                  <MembershipApplicationPage />
                </Layout>
              } />
              <Route path="/membership/application-status" element={
                <Layout>
                  <ApplicationStatusPage />
                </Layout>
              } />
              <Route path="/membership/application-success" element={
                <Layout>
                  <ApplicationSuccessPage />
                </Layout>
              } />

          {/* About routes */}
          <Route path="/about/executives" element={
            <ProtectedRoute>
              <Layout>
                <ExecutivesPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/about/executives/:id" element={
            <ProtectedRoute>
              <Layout>
                <ExecutiveDetailPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Main website routes - protected by feature flags */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <HomePage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/about" element={
            <ProtectedRoute>
              <Layout>
                <AboutPage />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/contact" element={
            <ProtectedRoute>
              <Layout>
                <ContactPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Catch all route */}
          <Route path="*" element={
            <ProtectedRoute>
              <Layout>
                <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">404 - Page Not Found</h1>
                    <p className="text-xl text-gray-600 mb-8">The page you're looking for doesn't exist.</p>
                    <a href="/" className="btn-primary">
                      Go Home
                    </a>
                  </div>
                </div>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;